import { template as template_225c8010c38943fab7083157b4b8b851 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import { Model } from '../../routes/render/icon';
export default RouteTemplate(template_225c8010c38943fab7083157b4b8b851(`
  <@model.Component />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
